import { Component, Input, Output, SimpleChanges, OnChanges, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Subscription, Observable, Observer } from 'rxjs/Rx';

import { SubscriptionHelper } from './../../shared/helpers';
import { ModalService, CustomersModalComponent, FocusOnInitDirective } from '@bhtp-client-web/component';
import { CustomerService, CustomerSimpleData, CustomerFullData } from './../../shared';

@Component({
    selector: 'customer-search',
    template: require('./customer-search.component.html')
})
export class CustomerSearchComponent implements OnChanges, OnInit {

    @Input() agentCode: string;

    @Output() public customerReturned: EventEmitter<CustomerFullData> = new EventEmitter<CustomerFullData>();

    public searchForm: FormGroup;
    public searchTextControl: FormControl;
    public searchText: string;

    private showSearch: boolean = false;
    private customerSelected = false;
    private displayText: string = 'Add Primary Traveler from Customer List';

    private formInitialized: boolean = false;
    private submitted: boolean = false;

    private customerSelectedSubscription: Subscription;
    private searchCustomerSubscription: Subscription;
    private customerFullDataSubscription: Subscription;

    private validationMessages: any = {
        'searchTextControl': {
            'required': 'Search text is required.'
        }
    };

    constructor(private formBuilder: FormBuilder, private customerService: CustomerService, private modalService: ModalService) { }

    public ngOnInit(): void {
        this.customerSelectedSubscription = this.modalService.getCustomersModalComponentRef().customerSelected
            .subscribe((customer: CustomerSimpleData) => {
                this.customerSelected = true;
                this.onCustomerSelectedFromModal(customer);
            }, error => { console.log(error); });
    }

    public ngOnDestroy(): void {
        this.customerSelectedSubscription = SubscriptionHelper.unsubscribeHandler(this.customerSelectedSubscription);
        this.customerFullDataSubscription = SubscriptionHelper.unsubscribeHandler(this.customerFullDataSubscription);
        this.searchCustomerSubscription = SubscriptionHelper.unsubscribeHandler(this.searchCustomerSubscription);
    }

    public ngOnChanges(): void {
        if (this.showSearch && !this.formInitialized) {
            this.buildForm();
        }
    }

    public buildForm(): void {
        this.searchForm = new FormGroup({});
        this.searchTextControl = this.formBuilder.control(this.searchText, [Validators.required]);
        this.searchForm.addControl('searchTextControl', this.searchTextControl);
        this.formInitialized = true;
    }

    public search(): void {
        this.submitted = true;

        if (this.searchForm.valid) {
            this.searchText = this.searchTextControl.value;

            this.modalService.showLoadingModal('Searching...');
            this.searchCustomerSubscription = this.customerService.searchCustomer(this.agentCode, this.searchText, '1', '10')
                .subscribe((result: Array<CustomerSimpleData>) => {
                    this.modalService.hideLoadingModal();

                    // todo: subscribe to 'onclose' for loading modal
                    setTimeout(() => this.displaySearchResults(result), 500);
                }, (error) => {
                    this.modalService.hideLoadingModal();

                    // todo: subscribe to 'onclose' for loading modal
                    setTimeout(() => this.modalService.showMessageModal('Error', 'Search Failed.'), 500);
                });
        }
    }

    public getCustomerFullData(customer: CustomerSimpleData): Observable<CustomerFullData> {
        return this.customerService.getCustomerById(this.agentCode, customer.customerId);
    }

    private displaySearchResults(customers: Array<CustomerSimpleData>): void {
        // Handled by this.customerSelectedSubscription
        this.modalService.showCustomersModalComponent(customers);
    }

    private onCustomerSelectedFromModal(customer: CustomerSimpleData): void {
        if (customer) {
            this.modalService.showLoadingModal('Getting Customer Data...');
            this.customerFullDataSubscription = this.getCustomerFullData(customer)
                .subscribe((customer: CustomerFullData) => {
                    this.modalService.hideLoadingModal();
                    this.customerReturned.emit(customer);
                },
                (error) => {
                    this.modalService.hideLoadingModal();
                    return Observable.empty();
                });
        }
    }

    private showSearchSwitch(): void {
        this.showSearch = !this.showSearch;
        this.ngOnChanges();
    }

    private switchDisplayText(): string {
        if (this.customerSelected) {
            this.displayText = 'Update Primary Traveler from Customer List';
        }

        return this.displayText;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/customer-search/customer-search.component.ts